import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, EmptyState } from "../components/Section";
import { MapPin, Phone, Clock, User } from "lucide-react";

export default function PrayerCenters() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/prayer-centers").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="prayer-centers-page">
      <PageHeader eyebrow="HOUSES OF PRAYER" title="Prayer Centers"
        subtitle="Find a Council prayer center near you and join us in intercession."
        bg="https://images.unsplash.com/photo-1519491050282-cf00c82424b4?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80" />
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          {items.length === 0 ? <EmptyState /> : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {items.map((p) => (
                <div key={p.id} data-testid={`prayer-center-${p.id}`} className="border hairline rounded-xl p-7 surface hover:border-gold/50 transition-colors duration-300">
                  <div className="font-accent text-[10px] text-gold mb-3">{p.city}{p.city && p.country ? ", " : ""}{p.country}</div>
                  <h3 className="font-display text-2xl text-white">{p.name}</h3>
                  <ul className="mt-5 space-y-3 text-sm text-zinc-300">
                    <li className="flex gap-3"><MapPin className="w-4 h-4 text-gold mt-0.5" /> {p.address}</li>
                    {p.contact && <li className="flex gap-3"><User className="w-4 h-4 text-gold mt-0.5" /> {p.contact}</li>}
                    {p.phone && <li className="flex gap-3"><Phone className="w-4 h-4 text-gold mt-0.5" /> {p.phone}</li>}
                    {p.schedule && <li className="flex gap-3"><Clock className="w-4 h-4 text-gold mt-0.5" /> {p.schedule}</li>}
                  </ul>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
